<template>
  <div id="schoolManagementForAdmin">
    <div class="container SchoolManagementForAdmin admin-wrap">
      <div class="row header mb-5">
        <div class="col-lg-5 ">
          <h3 class="text-left mb-3">{{lang('School Management')}} </h3>
        </div>
        <div class="col-lg-7">
          <div class="row searchingArea" style="margin-bottom:5px;"> 
                        <el-select v-model="ddlUniversity" :placeholder="lang('Select University')" class="pro-edt-select"
                              @change="getUserSchool()"  style="margin-left: auto!important;">
                            <el-option
                                    v-for="item in ddlUniversityList"
                                    :key="item.PK_UNI_ID"
                                    :label="item.UNI_Name"
                                    :value="item.PK_UNI_ID">
                            </el-option>
                        </el-select> 
                    </div>
                    </div> 
      </div>   
      <div class="pb-5">
        <div class="empty-list_image" v-if="schoolList.length<1">
          <strong>
            {{lang('No School Found...')}}
          </strong> 
          <img src="../assets/attendance.jpg"/>
        </div>
        <div class="text-center mg-b-pro-edt custom-pro-edt-ds col-lg-2 float-right">
                    <a href="/schoolManagementForAdminEdit" id="v-step-SaveButton" 
                    class="btn btn-primary waves-effect waves-light m-r-10">
                      Add School
                    </a>
                  </div>
                  <br />
              <div class="whitespace-30"></div>
        <div class="responsive-table" v-if="schoolList.length>0">
          <table class="table attTable">
              <tr> 
                <th>{{lang('School Name')}}</th>
                <th>{{lang('School Type')}}</th>
                <th>{{lang('School Code')}}</th>
                <th>{{lang('School City')}}</th> 
                <th>{{lang('Status')}}</th> 
              </tr> 
              <tr v-for='record in schoolList' v-bind:key='record.PK_SCH_ID'>
                <td><a target="_blank" :href="'/schoolManagementForAdminEdit?id=' + record.PK_SCH_ID" >{{record.SCH_Name}}</a></td>
                <td>{{record.SCH_Type}}</td>
                <td>{{record.SCHl_code}}</td>
                <td>{{record.SCH_City}}</td>
                <td>{{record.SCH_Status}}</td>                
              </tr>
            </table>
          </div> 
        </div>
    </div>
  </div>
</template>

<script>
import $ from "jquery";
import DataSource from "../data/datasource";
import Vue from "vue";
import { lang } from "../locale/index";
import { required } from "vuelidate/lib/validators";

import Cookies from "js-cookie";
export default {
  name: "SchoolManagementForAdmin",
   
  data() {
    return {
      ddlUniversity:'', // set default value to EH singapore
      ddlUniversityList:[],
      schoolList: [],
    };
  },
  async created() {
    this.$vs.loading();
   await this.getUniversity();
   await this.getUserSchool();
   this.$vs.loading.close();
  },
  methods: {
    lang,  
    async getUniversity() {
      try {
        const resp = await DataSource.shared.getUniversity(
          "",
          ""
        );
        if (resp) {
          if (resp.Table.length > 0) {
            this.ddlUniversityList = resp.Table;
          } 
        } else {
          console.log("Error");
        }
      } catch (e) {
        this.results = e;
      }
    },
    async getUserSchool() {
      this.schoolList = [];
      try {
        const resp = await DataSource.shared.getAllActiveSchool(
          "",
          this.ddlUniversity
        );
        if (resp) {
          if (resp.Table.length > 0) {
            this.schoolList = resp.Table;
            this.ddlUniversity='UTY201300000061';
          } 
        } else {
          console.log("Error");
        }
      } catch (e) {
        this.results = e;
      }
    },
 
  },
};
</script>
 